import styles from "./index.module.scss";
import { useCalculatorController } from "../../../context/context";
import CompleteRenewalBanner from "../../../banners/CompleteRenewalBanner";
import cn from "classnames";

const CATEGORY_CELL_WIDTH = 144;
const DATA_CELL_WIDTH = 100;
const RENEWAL_FIELD_MAX_COUNT = 5;

const TableBlur = () => {
  const { controller } = useCalculatorController();
  const { renewalFieldsCount, isCalcFormSubmitted, isMetricFormSubmitted } =
    controller;

  const blurOffset =
    isCalcFormSubmitted && isMetricFormSubmitted
      ? CATEGORY_CELL_WIDTH + (renewalFieldsCount + 1) * DATA_CELL_WIDTH
      : DATA_CELL_WIDTH;

  return (
    <div
      className={cn(
        styles.blur,
        renewalFieldsCount === 10 &&
          isCalcFormSubmitted &&
          isMetricFormSubmitted &&
          styles.hide_blur
      )}
      style={{ width: `calc(100% - ${blurOffset}px)` }}
    >
      {isMetricFormSubmitted &&
        isCalcFormSubmitted &&
        !(renewalFieldsCount > RENEWAL_FIELD_MAX_COUNT) && (
          <CompleteRenewalBanner />
        )}
    </div>
  );
};

export default TableBlur;
